import React from 'react'
import { useTranslation } from 'react-i18next'
import BorderPromoBanner from '../../../lib/banners/BorderPromoBanner'

function WhatIsRootsTechBanner() {
  const [t] = useTranslation()
  return (
    <BorderPromoBanner
      heading={t('what-is-rootstech.title', 'What is RootsTech?')}
      description={t(
        'what-is-rootstech.body',
        'RootsTech is a place to learn, to be inspired, and make connections through family history.'
      )}
      flavor="blueberry"
      buttonText={t('common-ui:learn-more.action', 'Learn More')}
      to="/about"
    />
  )
}

export default WhatIsRootsTechBanner
